/* eslint-disable no-shadow */
import { PATIENT_PROFILE } from '../actions/patient';

const state = {
  patient: {
    addingDate: '',
    id: -1,
    name: '',
    age: '',
    birthDate: '',
    hasAnamnesisErrors: false,
    hasBasicErrors: false,
  },
};

const getters = {
  patient: (state) => state.patient,
};

const actions = {};

const mutations = {
  [PATIENT_PROFILE]: (state, value) => {
    state.patient = value;
  },
};

export default () => ({
  state,
  getters,
  actions,
  mutations,
});
